// API configuration
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001';

// For auth routes, we need the base URL without /api
export const AUTH_BASE_URL = API_BASE.replace(/\/api$/, '');

// For API routes, we need the base URL with /api
export const API_BASE_URL = API_BASE.endsWith('/api') ? API_BASE : `${API_BASE}/api`;

export default {
  AUTH_BASE_URL,
  API_BASE_URL
};